import { render } from "./TermosAdesao.vue?vue&type=template&id=d6cf5388"
import script from "./TermosAdesao.vue?vue&type=script&lang=js"
export * from "./TermosAdesao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__